const COLLECTION_TITLES = {
  realEstate: [
    "Житло поруч 🏡",
    "Нерухомість для планів 🔑",
    "Простір для життя 🏠",
    "Квартири та будинки 🏘️",
    "Новий куточок для себе 🪟",
  ],

  transport: [
    "Транспортні знахідки 🚗",
    "Авто та мото 🛞",
    "Для дороги 🛣️",
    "Рухаємося далі 🚙",
    "Колеса, поїздки, плани 🏍️",
  ],

  gadgets: [
    "Гаджети та техніка 📱",
    "Техно-добірка ⚡",
    "Корисна електроніка 💻",
    "Смарт-знахідки 🔌",
    "Для цифрового життя 🎧",
  ],

  career: [
    "Карʼєрні можливості 💼",
    "Робота та підробіток 📌",
    "Для нових стартів 🚀",
    "Професійні пропозиції 🧑‍💻",
    "Можливості поруч 📈",
  ],

  services: [
    "Майстри поруч 🛠️",
    "Послуги, які виручають 🤝",
    "Корисні сервіси 🧰",
    "Для справ і задач ✅",
    "Знайдіть майстра 🔧",
  ],

  home: [
    "Для дому та затишку 🛋️",
    "Затишок вдома 🕯️",
    "Домашня атмосфера 🏠",
    "Ідеї для оселі ✨",
    "Красиве для простору 🪴",
    "Оновлення для дому 🧺",
  ],

  garden: [
    "Для саду та подвірʼя 🌿",
    "Садові знахідки 🌱",
    "Для подвірʼя 🪴",
    "Дача і сад 🌻",
    "Зелена добірка 🍃",
  ],

  kids: [
    "Для малечі 🧸",
    "Дитяча добірка 🍼",
    "Маленькі радощі 🎈",
    "Світ дитинства 🐣",
    "Для дітей і батьків 👶",
  ],

  pets: [
    "Для улюбленців 🐾",
    "Пухнасті знахідки 🐶",
    "Для котиків і песиків 🐱",
    "Турбота про тварин 🦴",
    "Домашні улюбленці ❤️",
  ],

  fashion: [
    "Стильний вибір 👗",
    "Модна підбірка ✨",
    "Образ на сьогодні 🧥",
    "Fashion mood 🖤",
    "Для гарного образу 👠",
    "Стильні знахідки 👜",
    "Одяг та взуття 👟",
  ],

  sports: [
    "Активність та спорт 🏃",
    "Для руху й енергії ⚽",
    "Спортивна добірка 🏋️",
    "Тренування і хобі 🚴",
    "Більше руху 💪",
  ],

  beauty: [
    "Бʼюті добірка 💄",
    "Краса та догляд ✨",
    "Для себе красивої 🧴",
    "Догляд і стиль 🌸",
    "Beauty mood 💅",
  ],

  education: [
    "Знання та навчання 📚",
    "Для розвитку 🧠",
    "Навчальна добірка ✏️",
    "Книги та курси 📖",
    "Прокачати себе 🚀",
  ],

  rental: [
    "Оренда та прокат 🔁",
    "Взяти на час ⏳",
    "Прокат поруч 📦",
    "Коли не треба купувати ✅",
    "Орендні знахідки 🧾",
  ],

  parts: [
    "Запчастини та аксесуари ⚙️",
    "Для ремонту й заміни 🔧",
    "Автодеталі поруч 🛞",
    "Корисні запчастини 🧰",
    "Для техніки і транспорту 🔩",
  ],

  accessories: [
    "Аксесуари та деталі 💍",
    "Маленькі акценти ✨",
    "Прикраси й аксесуари 👜",
    "Деталі образу 💫",
    "Стиль у дрібницях 🧿",
  ],

  food: [
    "Смачні знахідки 🍰",
    "Продукти та їжа 🥐",
    "Щось смачненьке 😋",
    "Їстівна добірка 🍓",
    "Смаколики поруч 🧁",
  ],

  hobby: [
    "Для хобі 🎨",
    "Творчі знахідки 🧩",
    "Час для себе ✨",
    "Хобі та натхнення 🎭",
    "Цікаві дрібниці 🪄",
  ],

  handmade: [
    "Ручна робота 🧶",
    "Handmade добірка ✨",
    "Створено вручну 🤲",
    "Теплі речі ручної роботи 🧵",
    "Авторські знахідки 🌿",
    "З любовʼю зроблено 💛",
  ],

  gifts: [
    "Ідеї для подарунків 🎁",
    "Подарункова добірка 💝",
    "Приємні знахідки ✨",
    "Що подарувати? 🎀",
    "Для особливого моменту 🌷",
  ],

  decor: [
    "Декор і деталі 🕯️",
    "Атмосферні речі ✨",
    "Декор для простору 🖼️",
    "Красиві дрібниці 🪴",
    "Для затишної атмосфери 🌙",
  ],
};

const CATEGORY_TYPE_MAP = {
  "житло та нерухомість": "realEstate",
  "транспорт": "transport",
  "гаджети": "gadgets",
  "карʼєра": "career",
  "кар'єра": "career",
  "майстри та послуги": "services",
  "дім та затишок": "home",
  "для саду та подвір'я": "garden",
  "для саду та подвірʼя": "garden",
  "малеча": "kids",
  "домашні улюбленці": "pets",
  "стиль": "fashion",
  "активність та спорт": "sports",
  "б’юті": "beauty",
  "б'юті": "beauty",
  "знання та навчання": "education",
  "оренда та прокат": "rental",
  "запчастини та аксесуари": "parts",
  "аксесуари": "accessories",
  "продукти та їжа": "food",
  "хобі": "hobby",
};

const FASHION_KEYWORDS = [
  "пальто",
  "куртк",
  "одяг",
  "сукн",
  "кофт",
  "светр",
  "сорочк",
  "футболк",
  "джинс",
  "штани",
  "спідниц",
  "кросів",
  "взут",
  "туф",
  "босоніж",
  "чобіт",
  "сумк",
  "клатч",
  "гардероб",
  "лук",
  "образ",
];

const ACCESSORIES_KEYWORDS = [
  "прикрас",
  "кольє",
  "браслет",
  "сереж",
  "каблуч",
  "намист",
  "бісер",
  "аксесуар",
  "брелок",
  "ланцюж",
];

const HOME_KEYWORDS = [
  "диван",
  "ліжк",
  "шаф",
  "подушк",
  "комод",
  "мебл",
  "крісл",
  "стіл",
  "стілець",
  "тумб",
  "полиц",
  "інтер",
  "плед",
  "покривал",
];

const DECOR_KEYWORDS = [
  "декор",
  "свічк",
  "картина",
  "ваза",
  "статует",
  "панно",
  "постер",
  "кашпо",
  "аромасвіч",
  "рамк",
];

const HANDMADE_KEYWORDS = [
  "handmade",
  "ручна робота",
  "ручн",
  "в'язан",
  "вʼязан",
  "вязан",
  "гачком",
  "спицями",
  "амігурумі",
  "зшит",
  "вишив",
  "макраме",
  "керамік",
  "авторськ",
  "створено вручну",
];

const GIFTS_KEYWORDS = [
  "букет",
  "подар",
  "сюрприз",
  "зефір",
  "цукер",
  "солодк",
  "набір",
  "композиці",
  "листівк",
  "свято",
];

const KIDS_KEYWORDS = [
  "дит",
  "малюк",
  "малеч",
  "іграшк",
  "ляльк",
  "зайчат",
  "ведмед",
  "розвиваюч",
];

const BEAUTY_KEYWORDS = [
  "космет",
  "краса",
  "догляд",
  "парф",
  "макіяж",
  "манікюр",
  "крем",
  "шампун",
];

const FOOD_KEYWORDS = [
  "їжа",
  "продукт",
  "торт",
  "капкейк",
  "кекс",
  "печив",
  "мед",
  "сир",
  "мʼяс",
  "м'яс",
  "овоч",
  "фрукт",
];

function normalize(str = "") {
  return String(str)
    .toLowerCase()
    .replace(/ё/g, "е")
    .replace(/ʼ/g, "'")
    .replace(/\s+/g, " ")
    .trim();
}

function includesAny(text, keywords = []) {
  return keywords.some((word) => text.includes(normalize(word)));
}

function seededShuffle(arr = [], seed = Date.now()) {
  const out = [...arr];
  let s = seed % 2147483647;
  if (s <= 0) s += 2147483646;

  const rand = () => {
    s = (s * 16807) % 2147483647;
    return (s - 1) / 2147483646;
  };

  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }

  return out;
}

function pickTitle(type, seed) {
  const variants = COLLECTION_TITLES[type] || ["Цікава добірка ✨"];
  return variants[Math.abs(seed) % variants.length];
}

function getItemCategoryType(item) {
  const category = normalize(item?.category);
  return CATEGORY_TYPE_MAP[category] || null;
}

function detectCollectionType(item) {
  const categoryType = getItemCategoryType(item);

  const category = normalize(item?.category);
  const title = normalize(item?.title);
  const desc = normalize(item?.description);

  const text = `${category} ${title} ${desc}`;

  /*
    Важливо:
    1. Категорія має пріоритет.
    2. "Стиль" не має потрапляти в handmade.
    3. "Пальто", "куртка", "одяг" завжди fashion.
    4. Handmade — тільки коли справді є ознаки ручної роботи.
  */

  if (categoryType === "fashion") return "fashion";
  if (categoryType === "accessories") return "accessories";
  if (categoryType === "home") return "home";
  if (categoryType === "kids") return "kids";
  if (categoryType === "beauty") return "beauty";
  if (categoryType === "food") return "food";
  if (categoryType === "pets") return "pets";
  if (categoryType === "garden") return "garden";
  if (categoryType === "sports") return "sports";
  if (categoryType === "gadgets") return "gadgets";
  if (categoryType === "transport") return "transport";
  if (categoryType === "realEstate") return "realEstate";
  if (categoryType === "career") return "career";
  if (categoryType === "services") return "services";
  if (categoryType === "education") return "education";
  if (categoryType === "rental") return "rental";
  if (categoryType === "parts") return "parts";

  if (includesAny(text, FASHION_KEYWORDS)) return "fashion";

  if (includesAny(text, BEAUTY_KEYWORDS)) return "beauty";

  if (includesAny(text, FOOD_KEYWORDS)) return "food";

  if (includesAny(text, HOME_KEYWORDS)) return "home";

  if (includesAny(text, DECOR_KEYWORDS)) return "decor";

  if (includesAny(text, ACCESSORIES_KEYWORDS)) {
    if (includesAny(text, HANDMADE_KEYWORDS)) return "handmade";
    return "accessories";
  }

  if (includesAny(text, KIDS_KEYWORDS)) {
    if (includesAny(text, HANDMADE_KEYWORDS)) return "handmade";
    return "kids";
  }

  if (includesAny(text, GIFTS_KEYWORDS)) {
    if (includesAny(text, FOOD_KEYWORDS)) return "food";
    return "gifts";
  }

  if (includesAny(text, HANDMADE_KEYWORDS)) return "handmade";

  if (categoryType === "hobby") return "hobby";

  return null;
}

function getCollectionQualityScore(type, list = []) {
  const count = Array.isArray(list) ? list.length : 0;

  const baseScore = {
    fashion: 95,
    accessories: 92,
    home: 90,
    handmade: 88,
    gifts: 86,
    kids: 84,
    beauty: 82,
    food: 80,
    decor: 78,
    hobby: 76,
  }[type] || 60;

  return baseScore + Math.min(count, 12);
}

export function buildDynamicCollections(items = [], seed = Date.now()) {
  const source = Array.isArray(items) ? items : [];

  const normalListings = source.filter((item) => {
    const isListing = item?.cardType === "listing";
    const isWanted =
      String(item?.listingType || item?.typeRaw || "").toLowerCase() ===
      "wanted";

    return isListing && !isWanted;
  });

  const groups = new Map();

  normalListings.forEach((item) => {
    const type = detectCollectionType(item);
    if (!type) return;

    if (!groups.has(type)) {
      groups.set(type, []);
    }

    groups.get(type).push(item);
  });

  const collections = [];

  Array.from(groups.entries()).forEach(([type, list], index) => {
    const uniq = [];
    const seen = new Set();

    list.forEach((item) => {
      const id = String(item?.listingId || item?.id || "");
      if (!id || seen.has(id)) return;

      seen.add(id);
      uniq.push(item);
    });

    if (uniq.length < 4) return;

    const freshSorted = uniq.sort(
      (a, b) => Number(b?.createdAt || 0) - Number(a?.createdAt || 0)
    );

    const shuffled = seededShuffle(freshSorted, seed + index * 101);

    const previewItems = shuffled.slice(0, 4);
    const modalItems = shuffled.slice(0, 20);

    collections.push({
      id: `${type}-${seed}-${index}`,
      type,
      title: pickTitle(type, seed + index),
      previewItems,
      items: modalItems,
      total: modalItems.length,
      score: getCollectionQualityScore(type, modalItems),
    });
  });

  return seededShuffle(
  collections.sort((a, b) => Number(b.score || 0) - Number(a.score || 0)),
  seed
 ).slice(0, 8);
}